var drawCircle = function (ctx, num, total, oringinX, oringinY, width = 3, length = 30, color = '#000', time = 500) {
  let ratio = ((num / total) * 2).toFixed(2) - 0
  let step = ratio / (time / 5)
  let begin = 0
  let end = begin + step
  let a = setInterval(() => {
    if (end - ratio > -0.01) {
      clearInterval(a)
      return
    }
    ctx.clearRect(0, 0, oringinX * 2, oringinY * 2)

    // 文字
    // ctx.font = 12 + 'px April'
    // ctx.textAlign = 'center'
    // ctx.textBaseline = 'middle'
    // ctx.fillStyle = '#1A3D5E'
    // ctx.fillText(num + '/' + total, oringinX, oringinY)

    ctx.beginPath()

    ctx.strokeStyle = color

    ctx.lineCap = 'round'

    ctx.lineWidth = width

    // 渐变色
    // let linGrad = ctx.createLinearGradient(
    //   oringinX + length + width, 0, oringinX - length - width, oringinY
    // )
    // linGrad.addColorStop(0.5, 'black')
    // linGrad.addColorStop(0.0, 'red')
    // linGrad.addColorStop(1.0, '#00f8bb')
    // ctx.strokeStyle = linGrad
    ctx.arc(oringinX, oringinY, length, (begin - 0.5) * Math.PI, (-0.5 + end) * Math.PI)
    ctx.stroke()
    ctx.closePath()
    end = end + step
    if (end > ratio * 0.9) {
      step = ratio / (time / 5) * 0.25
    } else if (end > ratio * 0.8) {
      step = ratio / (time / 5) * 0.35
    } else if (end > ratio * 0.7) {
      step = ratio / (time / 5) * 0.55
    }
  }, 10)
}
export default drawCircle
